(() => {
  const root = document.documentElement;
  const key = 'walletclub-theme';
  let saved = 'light';
  try { saved = localStorage.getItem(key) === 'dark' ? 'dark' : 'light'; } catch {}
  root.dataset.theme = saved;
  function updateButton() {
    const button = document.getElementById('wc-theme-toggle');
    if (!button) return;
    const dark = root.dataset.theme === 'dark';
    button.setAttribute('aria-pressed', String(dark));
    button.setAttribute('aria-label', dark ? button.dataset.lightLabel : button.dataset.darkLabel);
  }
  function attach() {
    const button = document.getElementById('wc-theme-toggle');
    if (!button) return;
    updateButton();
    button.addEventListener('click', () => {
      root.dataset.theme = root.dataset.theme === 'dark' ? 'light' : 'dark';
      try { localStorage.setItem(key, root.dataset.theme); } catch {}
      updateButton();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', attach, {once:true});
  else attach();
  window.addEventListener('storage', event => {
    if (event.key !== key) return;
    root.dataset.theme = event.newValue === 'dark' ? 'dark' : 'light';
    updateButton();
  });
})();
